var $d3182189bfd1bf3b$exports = {};
$d3182189bfd1bf3b$exports = {
    "longPressMessage": `Nyomja meg hosszan, vagy nyomja meg az Alt + lefele ny\xedl gombot a men\xfc megnyit\xe1s\xe1hoz`
};


export {$d3182189bfd1bf3b$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
